import VendaFab from './VendaFab';

export default VendaFab;
